import React from 'react';
import { Route, Switch } from 'react-router-dom';

import map from './map';
import { AddEditAtt } from './AddEditAtt';
import { ViewAtt } from './ViewAtt';
import ProtectedRoute from '../PrivateRoute';

function Attorneys({ match }) {
    const { path } = match;

    return (
        <Switch>
            <ProtectedRoute exact path={path} component={map} />
            <Route path="/attorneys/add" component={AddEditAtt} />
            <Route path={`${path}/edit/:id`} component={AddEditAtt} />
            <Route path={`${path}/view/:id`} component={ViewAtt} />
        </Switch>
    );
}

export { Attorneys };